<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        
        <h3>
          {{$t('report_total')}}
        </h3>

        <b-form-group :label="$t('dateFromTo') + ':'" class="ml-2">
          <VueDataPicker
            v-model="dateFilter"
            placeholder=""
            :other-props="{ 'is-range': true }"
            @input="datePicker"
          />
        </b-form-group>
        
        <b-form-group :label="$t('dateFromTo') + ':'" class="ml-2">
          <VueDataPicker
            v-model="dateFilter2"
            placeholder=""
            :other-props="{ 'is-range': true }"
            @input="datePicker2"
          />
        </b-form-group>

      </div>

      <b-button
        :title="$t('excel')"
        size="sm"
        variant="success"
        class=""
        @click="downloadExcel()"
      >
        <feather-icon icon="DownloadIcon" size="15" />
      </b-button>
    </div>
    


      <!-- :busy="loader" -->
    <b-table
      :items="report_requirement_for_brigade.data"
      :fields="fields"
      small
      responsive
      bordered
      striped
      show-empty
    >
      <template #table-busy>
        <div
          class="text-success my-2 d-flex justify-content-center align-items-center"
        >
          <b-spinner />
          <strong class="px-1">Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div class="text-center text-danger my-2">
          <strong>
            {{ $t("objects.no_data") }}
          </strong>
        </div>
      </template>

      <template #thead-top>
        <b-tr class="text-center">
          <b-th colspan="2">
            <span class="sr-only">Name and ID</span>
          </b-th>
          <b-th variant="secondary" colspan="2">
            Жами нарядлар
          </b-th>
          <b-th variant="primary" colspan="2">
            Тўланган нарядлар
          </b-th>
          <b-th variant="danger" colspan="3">
            Қисман тўлов
          </b-th>
          <b-th variant="danger" colspan="2">
            Қарздорлик мавжуд нарядлар 
          </b-th>
        </b-tr>
      </template>



      <template #custom-foot>
        <b-tr class="text-center">
          <b-th variant="secondary">
            <span></span>
          </b-th>
          <b-th variant="secondary">
            <span>Жами</span>
          </b-th>
          <b-th variant="secondary">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_count) }}
          </b-th>
          <b-th variant="primary">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_fully_paid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_fully_paid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_partial_paid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_total_partial_unpaid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_total_partial_paid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_unpaid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade.total.total_unpaid_sum) }}
          </b-th>
        </b-tr>
      </template>



      <template #cell(numeration)="props">
        {{ props.index + 1 }}
      </template>
      
      <template #cell(total_count)="props">
        {{ $_formatPriceMixin(props.item.total_count) }}
      </template>
      <template #cell(total_sum)="props">
        {{ $_formatPriceMixin(props.item.total_sum) }}
      </template>
      <template #cell(fully_paid_count)="props">
        {{ $_formatPriceMixin(props.item.fully_paid_count) }}
      </template>
      <template #cell(fully_paid_sum)="props">
        {{ $_formatPriceMixin(props.item.fully_paid_sum) }}
      </template>
      <template #cell(partial_paid_count)="props">
        {{ $_formatPriceMixin(props.item.partial_paid_count) }}
      </template>
      <template #cell(total_partial_unpaid_sum)="props">
        {{ $_formatPriceMixin(props.item.total_partial_unpaid_sum) }}
      </template>
      <template #cell(total_partial_paid_sum)="props">
        {{ $_formatPriceMixin(props.item.total_partial_paid_sum) }}
      </template>
      <template #cell(total_unpaid_count)="props">
        {{ $_formatPriceMixin(props.item.total_unpaid_count) }}
      </template>
      <template #cell(total_unpaid_sum)="props">
        {{ $_formatPriceMixin(props.item.total_unpaid_sum) }}
      </template>



    </b-table>




  </b-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { BCard, BSpinner, BTr, BTh, BTable, BButton, BFormGroup } from "bootstrap-vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import moment from 'moment'
import VueDataPicker from "@/components/VueDatePicker.vue";


export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
    BButton,
    BFormGroup,
    VueDataPicker,
  },
  mixins: [priceFormatMixin],

  data() {
    return {
      loader: true,
      items: [],

      dateFilter: {
        start_date: null,
        end_date: null,
      },

      dateFilter2: {
        paid_date_start: null,
        paid_date_end: null,
      },


      fields: [
        {
          key: "numeration",
          label: "№",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "object",
          label: "Объект номи",
        },
        {
          key: "total_count",
          label: "сони",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sum",
          label: "суммаси",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "fully_paid_count",
          label: "сони",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "fully_paid_sum",
          label: "суммаси",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "partial_paid_count",
          label: "сони",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_partial_unpaid_sum",
          label: "Тўланмаган сумма",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_partial_paid_sum",
          label: "Тўланган сумма",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_unpaid_count",
          label: "сони",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_unpaid_sum",
          label: "суммаси",
          thClass: "text-center",
          tdClass: "text-center",
        },
     
      ],
    };
  },

  computed: {
    ...mapState("application", ["report_requirement_for_brigade"]),


   
  },

  async mounted() {

    await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE()

  },

  methods: {
    ...mapActions("application", ["FETCH_REPORT_REQUIREMENT_FOR_BRIGADE"]),

    



    async downloadExcel() {
      await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE({blob: true, excel: true}).then((res) => {


        const url = window.URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          })
        );
        const date = new Date();
        const fullDate = moment(date).format("DD-MM-YYYY");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fullDate);
        document.body.appendChild(link);
        link.click();



      });
    },







    // ===============  DATE_PICKER_SECTION START ===============
    async datePicker(e) {
      if (e) {
        this.dateFilter.start_date = e.start;
        this.dateFilter.end_date = e.end;
        await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE({
          work_date_start: this.dateFilter.start_date,
          work_date_end: this.dateFilter.end_date,

          paid_date_start: this.dateFilter2.paid_date_start,
          paid_date_end: this.dateFilter2.paid_date_end,
        });
      } else {
        await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE();
      }
    },
    async datePicker2(e) {
      if (e) {
        this.dateFilter2.paid_date_start = e.start;
        this.dateFilter2.paid_date_end = e.end;
        await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE({
          paid_date_start: this.dateFilter2.paid_date_start,
          paid_date_end: this.dateFilter2.paid_date_end,
        });
      } else {
        await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE();
      }
    },
    // ===============  DATE_PICKER_SECTION END ===============








  },
};
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}
</style>
